import {
	ETableStructureAlign,
	ETableStructureType,
	TEmValue,
	TTableStructure,
} from 'ui/EasTable/types';
import { TLaunchedScriptRow } from './types';

export const tableStructure: TTableStructure<keyof TLaunchedScriptRow, TLaunchedScriptRow>[] = [
	{
		name: 'ID',
		selector: 'id',
		show: false,
		sortable: false,
		filterable: false,
		colSpan: 1,
		type: ETableStructureType.NUMBER,
		align: ETableStructureAlign.LEFT,
	},
	{
		name: 'Updated At',
		selector: 'updatedAt',
		show: true,
		sortable: false,
		filterable: false,
		colSpan: 2,
		type: ETableStructureType.DATE_TIME,
		align: ETableStructureAlign.LEFT,
	},

	{
		name: 'Applied Rule',
		selector: 'appliedRule',
		show: true,
		sortable: false,
		filterable: false,
		colSpan: 3,
		type: ETableStructureType.STRING,
		align: ETableStructureAlign.LEFT,
	},
	{
		name: 'EM ID',
		selector: 'emId',
		show: false,
		sortable: false,
		filterable: false,
		colSpan: 1,
		type: ETableStructureType.NUMBER,
		align: ETableStructureAlign.LEFT,
	},
	{
		name: 'Author',
		selector: 'author',
		show: true,
		sortable: false,
		filterable: false,
		colSpan: 2,
		type: ETableStructureType.USER,
		align: ETableStructureAlign.LEFT,
		value: (item) =>
			({
				id: '0',
				email: '',
				fullName: item.author ?? '',
			}) as unknown as TEmValue,
	},
];
